<template>
  <v-scale-transition origin="center">
    <v-btn
      v-show="fab"
      v-scroll="onScroll"
      :class="$style.button"
      tile
      icon
      color="white"
      @click="gotoTop"
    >
      <v-icon x-large dark>mdi-chevron-up</v-icon>
    </v-btn>
  </v-scale-transition>
</template>
<script>
export default {
  name: 'BaseBackToTop',
  data: () => ({ fab: false }),
  methods: {
    gotoTop() {
      // window.scrollTo(0, 0)
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    onScroll() {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || document.documentElement.offsetTop || 0
      this.fab = top > 300
    },
  },
}
</script>
<style lang="scss" module>
.button {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    display: block;
  }
  position: fixed;
  right: 1rem;
  bottom: 5rem;
  z-index: 999;

  display: none;

  background: var(--primary) !important;
}
</style>
